import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { notifyError } from '../../utils/notifications';
import { VesselOperationCard } from './VesselOperationCard';
import { BasicVesselSettingsCard } from './BasicVesselSettingsCard';
import { SubscriptionCard } from './SubscriptionCard';
import { TechnicalInfoCard } from './TechnicalInfoCard';
import { WkoLoadingSpinner } from '../WkoLoadingSpinner';
export function VesselDetailsPage({ imo }) {
    const [vessel, setVessel] = useState(null);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        let isCancelled = false;
        const load = async () => {
            setLoading(true);
            const response = await fetch(`/api/fleets/vessel/${imo}`);
            if (isCancelled) {
                return;
            }
            if (!response.ok) {
                notifyError('An error has occurred loading the vessel details. Please try again');
                setLoading(false);
                return;
            }
            const data = await response.json();
            setVessel(data);
            setLoading(false);
        };
        load();
        return () => {
            isCancelled = true;
        };
    }, [imo]);
    if (loading) {
        return _jsx(WkoLoadingSpinner, {});
    }
    if (!vessel) {
        return null;
    }
    return (_jsxs("div", { children: [_jsx(VesselOperationCard, { vessel: vessel }), _jsx(SubscriptionCard, { vessel: vessel }), _jsx(TechnicalInfoCard, { vessel: vessel }), _jsx(BasicVesselSettingsCard, { vessel: vessel })] }));
}
